import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { HotelDisclaimer } from 'app/typings';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

type Copywriting = {
  description?: string;
  valueProposition?: string;
  disclaimers?: HotelDisclaimer[];
};

export function useHotelCopywriting(hotelId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: Copywriting) =>
      apiMutation(
        'PATCH',
        {
          path: ENDPOINTS.updateCopywriting,
          params: { id: hotelId.toString() },
        },
        payload
      ) as Promise<void>,
    onSuccess: () => {
      message.success('Copywriting successfully saved');
      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.hotel],
      });
    },
    onError: () => {
      message.error('Error while saving copywriting');
    },
  });
}
